/* eslint-disable camelcase */
import url from './url'
import axios from 'axios'
import { originalAxios } from '@/api/axios'
import { RouteLocationNormalized } from 'vue-router'

// @ts-ignore
const ENV = window.envConfig
const oauth = {
  oAuthParams: {
    client_id: ENV['clientId'],
    state: 'init',
    redirect_uri: `${url.getApiBaseUrl()}${ENV['redirectUrlPath']}`,
    authorization_url: `${ENV['oauthUrl']}${ENV['authorizationUrlPath']}`,
    tokenUrl: `${ENV['apiBaseUrl']}${ENV['tokenUrlPath']}`,
    refreshTokenUrl: `${ENV['apiBaseUrl']}${ENV['refreshTokenUrlPath']}`,
    identityURL: `${ENV['identityUrl']}${ENV['identityUserUrlPath']}`
  },
  isAuthorized() {
    return this.hasAccessToken() && !this.isExpired()
  },
  isGoingToExpire() {
    return this.getExpiresIn() - 5 * 60 * 1000 < Date.now()
  },
  isExpired() {
    return this.getExpiresIn() < Date.now()
  },
  hasAccessToken() {
    return !!this.getTokens().token
  },
  getExpiresIn() {
    return this.getTokens().expire
  },
  generateExpireTime(expiresIn: number) {
    return Date.now() + expiresIn * 1000
  },
  setTokens(tokens: { expire: number }) {
    const expireTime = this.generateExpireTime(tokens.expire)
    tokens.expire = expireTime
    window.localStorage.setItem('OAUTH_TOKENS', JSON.stringify(tokens))
  },
  getTokens() {
    const tokens = window.localStorage.getItem('OAUTH_TOKENS')
    return tokens
      ? JSON.parse(tokens)
      : {
          env: '',
          token: '',
          expire: 0,
          tokenCategory: '',
          tokenType: ''
        }
  },
  removeTokens() {
    window.localStorage.removeItem('OAUTH_TOKENS')
  },
  getAccessToken() {
    return `${this.getTokens().token}`
  },
  redirectForAuthCode(to: RouteLocationNormalized) {
    this.setOAuthToPath(to)
    const client_id = this.getClientId()
    const authUrl = `${this.oAuthParams.authorization_url}?response_type=code&scope=Identity:Organization webex-mct:mct-api Identity:SCIM webex-mct:mct_resource&client_id=${client_id}&redirect_uri=${this.oAuthParams.redirect_uri}?oauth_provider_type=ClopsProvider`
    window.location.replace(authUrl)
  },
  setOAuthToPath(to: RouteLocationNormalized) {
    to && window.localStorage.setItem('OAUTH_TO_PATH', to.fullPath)
  },
  getOAuthToPath() {
    return window.localStorage.getItem('OAUTH_TO_PATH')
  },
  getUserInfoWithAccessToken() {
    return originalAxios({
      url: this.oAuthParams.identityURL,
      method: 'get',
      headers: {
        Authorization: `Bearer ${this.getAccessToken()}`
      }
    })
  },
  parseParams() {
    const params: {
      [key: string]: string
    } = {}
    const queryString = window.location.search.substring(1)
    let mark
    const regex = /([^&=]+)=([^&]*)/g
    while ((mark = regex.exec(queryString)) !== null) {
      params[decodeURIComponent(mark[1])] = decodeURIComponent(mark[2])
    }

    return params
  },
  getClientId() {
    return this.oAuthParams.client_id
  },
  getAuthCode() {
    const params = this.parseParams()
    return params.state === this.oAuthParams.state ? params.code : ''
  },
  getAccessTokenWithAuthCode(code: string) {
    return originalAxios({
      method: 'get',
      url: `${this.oAuthParams.tokenUrl}`,
      params: {
        redirectUri: `${this.oAuthParams.redirect_uri}?oauth_provider_type=ClopsProvider`,
        // scope: 'Identity:Organization Identity:Config Identity:SCIM',
        // oauth_provider_type: 'ClopsProvider',
        code: code
      }
    })
  },

  getRefreshToken() {
    return this.getTokens().refresh_token
  },
  refreshToken() {
    const data = `refreshToken=${this.getRefreshToken()}`
    return axios
      .get(`this.oAuthParams.refreshTokenUrl${data}`)
      .then((res) => {
        return res.data
      })
      .catch(() => {
        // @ts-ignore
        this.redirectForAuthCode()
      })
  },
  logout() {
    const logout_url = `${
      ENV['oauthUrl']
    }/idb/oauth2/v1/logout?goto=${url.getApiBaseUrl()}`
    originalAxios({
      url: logout_url,
      method: 'get',
      headers: {
        Authorization: `Bearer ${this.getAccessToken()}`
      }
    })
    this.removeTokens()
    window.location.replace('/logout')
  }
}

export default oauth
